import React, { Component } from 'react';
import CreatePrize from './CreatePrize.js';
import EditPrize from './EditPrize.js';
import Modal from 'react-modal';
import sparkles2 from '../asset/img/sparkles2.png';
export default class ManagePrizes extends Component {
	constructor(props){
		super(props);
		this.state = {newPrize:'',editedPrize:[],currentVariants:[],failed:false};
		this.viewVariants = this.viewVariants.bind(this);
		this.openModal = this.openModal.bind(this);
		this.closeModal = this.closeModal.bind(this);
	}

	viewVariants(e){ //method that retrieves all prize variants for user to see for the prize that they have selected
		let ID = e.target.id;
		let variants = [];
		this.props.prizes.forEach((prizes)=>{
			if(Number(prizes.prizeID) === Number(ID)){
				variants = prizes.variants;
			}
		});
		this.setState({currentVariants:variants},function(){
			this.openModal();
		});
	}

	openModal(){ //open the modal
		this.setState({modalIsOpen:true});
	}

	closeModal(){ //close the modal
		this.setState({modalIsOpen:false});
	}

	render(){
		const customStyles = {
		  content : {
		    top: '50%',
		    left: '50%',
		    right: 'auto',
		    bottom: 'auto',
		    width:'80%',
		    transform: 'translate(-50%, -50%)',
		    borderWidth:'1px',
		    borderColor:'gray',
		    minHeight:'350px',
		    maxWidth:'630px',
		    boxShadow:'0.5px 0.5px 1px 0.5px'
			}, 
			overlay:{
				backgroundColor:'rgba(105,105,105,0.8)'
			} 
		};
		const picstyles= {display:'block', maxWidth:'100px',maxHeight:'122px',width:'auto',height:'auto',margin:'auto'};
		let prizes;
		let variants;
		let pStyles = "mt0 pt3 fl w-100 b navy mb3 bb b--light-silver";
			if(!((this.props.create) || (this.props.edit)) && this.props.prizes.length>0){ //display all prizes for the selected year
				prizes= this.props.prizes.map((prizes,i)=>{
					const cap = prizes.cap === null?"none":prizes.cap;
					let photo = prizes.picture + prizes.variants[0].photo;
					photo=photo.replace(/\s/g,"_");
					return(<div className="fl w-50-ns mb2 w-100-m w-100 pa1" key={i}><div style={{maxWidth:'460px',margin:'auto',height:'250px'}} className="ba overflow-y-hidden ma2 pa2 bw1 b--light-silver br3 shadow-3 bg-white">
									<div className="fl w-60" style={{minHeight:'200px',maxHeight:'200px'}}>
										<p className="mt0 pt2 tc b mr2">{prizes.prize}</p>
										<img src={photo} alt="error" style={picstyles} className="mr2"/>
										<p className="tc mr2">{prizes.description}</p>
									</div>
									<div className="fl w-40">
										<div className="fl w-100" style={{height:'100%'}}>
											<p className={pStyles}><span className="b">Tier: </span>{prizes.tier}</p>
											<p className={pStyles}><span className="b">Cap: </span>{cap}</p>
											<p className={pStyles}><span className="b">Status: </span>{prizes.status}</p>
											<button className="br2 bg-navy white pa1 mt2 b" id={prizes.prizeID} onClick={this.viewVariants}>View Variants</button>
										</div>
									</div>
								</div></div>);
				});
				if(this.state.currentVariants !== ''){ //return a list of all prize variants for selected prize if user clicks "View Variants" button
					variants = this.state.currentVariants.map((variants,i)=>{
						const size = ((variants.size === null)||(variants.size === undefined)||(variants.size ===''))?"N/A":variants.size;
						const color = ((variants.color === null)||(variants.color === undefined)||(variants.color ===''))?"N/A":variants.color;
						return <li key={i}><p className="fl w-33 tc bb b--light-silver">{size}</p><p className="fl w-33 tc bb b--light-silver">{color}</p><p className="fl w-33 tc bb b--light-silver">{variants.status}</p></li>;
					});
				}
			}else if(this.props.create){ //if user clicks create, display CreatePrize component
				prizes = <CreatePrize save={this.props.save} year={this.props.year} reset={this.props.reset} tiers={this.props.tiers} revertSave={this.props.revertSave}/>
			}else if(this.props.edit){ //if user clicks edit, display EditPrize component
				if(this.props.prizes.length>0){ //check to make sure there have been prizes created for the current selected year
				prizes = <EditPrize save={this.props.save} year={this.props.year} prizes={this.props.prizes} reset={this.props.reset} onClose={this.props.onClose} revertSave={this.props.revertSave} tiers={this.props.tiers}/>;
				}else{
					prizes = <p className="w-100 f3 tc">There is nothing to view at this time.</p>;
				}
			}else{
				prizes = <p className="w-100 f3 tc">There is nothing to view at this time.</p>;
			}
		return(
			<div>
				<div className="pa3">
					{prizes}
				</div>
				<Modal
		          isOpen={this.state.modalIsOpen}
		          onRequestClose={this.closeModal}
		          shouldCloseOnOverlayClick={false}
						  shouldCloseOnEsc={false}
		          style={customStyles}
		          contentLabel="Registration Modal"
		        >
		        <div className="fl w-100 tr">
						  <button className="bg-white gray b br3" onClick={this.closeModal}>X</button>
						</div>
		   		<div className="fl w-100 mt2">
		   			<ul className="list pl3 mt0">
							<li className=""><p className="b bb b--dark-gray bw1 tc fl w-33">Size</p><p className="b bb b--gray tc bw1 fl w-33">Color</p><p className="b bb b--gray tc bw1 fl w-33">Status</p></li>
						</ul>
						<div className="overflow-y-auto fl w-100" style={{maxHeight:'200px',minHeight:'250px'}}>
							<ul className="list pl3 mt0">
								{variants}
							</ul>
						</div>
					</div>
		    </Modal>
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/container/ManagePrizes.js